export default "__VITE_ASSET__DnohpP_m__"